/**
 * Production release feature gates.
 *
 * Mission Control remains in the codebase for a future customer-facing
 * operational dashboard. Set MISSION_CONTROL_ENABLED to true when ready
 * to expose it in production builds.
 */
export const MISSION_CONTROL_ENABLED = false;

export function isMissionControlEnabled() {
  return MISSION_CONTROL_ENABLED;
}

/** @internal Capability keys gated while Mission Control is disabled. */
export const MISSION_CONTROL_CAPABILITIES = new Set([
  "mission_control.operational.view",
  "mission_control.development.view",
  "screen.mission_control",
]);

export function isMissionControlCapability(capability) {
  return MISSION_CONTROL_CAPABILITIES.has(capability);
}
